import Loadable from 'react-loadable';

import { ExamplesModalProps } from '../types';

export const ExamplesModal = Loadable<ExamplesModalProps, any>({
  loader: () => import(/* webpackChunkName: "ShowExamplesModal" */ './ExamplesModal'),
  loading: () => null,
});
